import router from "./router";
import i18n from "./i18n";
import store from "./store";

export const organizationModuleRouter = router;
export const organizationModuleI18n = i18n;
export const organizationModuleStore = store;
